import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import moment from "moment";
import PaginationComponent from "../../../components/comman/PaginationComponent";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import { formatAmount, getCurrentFinancialYear } from "../../../utility/CommonFunctions";
import { Spinner } from "reactstrap";
import MainHeading from "../../../components/comman/MainHeading";
import DayBookIcon from "../../../components/Icons/DayBookIcon";
import Chart from "react-apexcharts";

export default function CustomerLedgerDetail() {
  let { id } = useParams();
  const userDetails = useSelector((state) => state.root.userDetails);
  const location = useLocation();
  const navigate = useNavigate();
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    searchQuery: "",
    sortByDate: [
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    year: getCurrentFinancialYear(),
    CustomerLedgerData: [],
    countsData: {},
    companyList: [],
    companyId: "",
    siteId: "",
    siteList: [],
  });
  const [activeTab, setActiveTab] = useState({
    creditTab: false,
    debitTab: true,
    Tds: false,
  });
  const [selectedMonth, setSelectedMonth] = useState("");
  const [viewMode, setViewMode] = useState("dashboard"); // "table" | "dashboard"
  const [invoiceStats, setInvoiceStats] = useState({
    paidCount: 0,
    paidAmount: 0,
    pendingCount: 0,
    pendingAmount: 0,
    totalInvoiceAmount: 0,
    totalReceivedAmount: 0,
    tdsAmount: 0,
    collectionEfficiency: 0,
    totalContractValue: 0,
  });
  const [dashboardData, setDashboardData] = useState({
    workOrders: [],
    monthlySeries: [],
    monthlyCategories: [],
    statusSeries: [0, 0, 0],
    agingCategories: ["0-30 Days", "31-60 Days", "61-90 Days", ">90 Days"],
    agingSeries: [],
    paymentChannelsCategories: [],
    paymentChannelsSeries: [],
    recentCollections: [],
    averageDaysToCollect: 0,
  });

  useEffect(() => {
    GetCustomerLedgerData();
  }, [
    pageStates?.currentPage,
    pageStates?.searchQuery,
    pageStates?.pageSize,
    pageStates?.sortByDate,
    pageStates?.year,
    pageStates?.companyId,
    pageStates?.siteId,
    activeTab,
  ]);

  useEffect(() => {
    GetSiteList();
  }, []);

  const GetSiteList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_site + `?type=site&pageSize=${100}&customerId=${id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          siteList: response?.data?.site,
        }));
      }
    });
  };

  const fetchInvoiceStats = () => {
    let filterParams = `?customerId=${id}`;
    if (pageStates.siteId) {
      filterParams += `&siteId=${pageStates.siteId}`;
    }
    if (pageStates.sortByDate && pageStates.sortByDate.length === 2) {
      filterParams += `&startDate=${pageStates.sortByDate[0]}&endDate=${pageStates.sortByDate[1]}`;
    }
    if (pageStates.year) {
      filterParams += `&year=${pageStates.year}`;
    }

    const Url = `${apiUrl.get_customer_dashboard_stats}${filterParams}`;
    callApi(Url, { method: "GET" }).then((res) => {
      if (res?.status === true && res?.data) {
        const d = res.data;
        const k = d.kpis || {};
        const breakdown = d.invoiceStatusBreakdown || {};

        setInvoiceStats({
          paidCount: breakdown.fullyPaid || 0,
          paidAmount: Number(k.totalCollected) || 0,
          pendingCount: breakdown.unpaid || 0,
          pendingAmount: Number(k.totalPending) || 0,
          totalInvoiceAmount: Number(k.totalBilled) || 0,
          totalReceivedAmount: Number(k.totalCollected) || 0,
          tdsAmount: Number(k.tdsDeducted) || 0,
          collectionEfficiency: Number(k.collectionEfficiency) || 0,
          totalContractValue: Number(k.totalContractValue) || 0,
        });

        const trends = d.monthlyTrends || [];
        const monthlyCategories = trends.map((t) => t.month);
        const billingSeries = trends.map((t) => Number(t.billed) || 0);
        const collectionSeries = trends.map((t) => Number(t.collected) || 0);

        setDashboardData({
          workOrders: d.workOrders || [],
          monthlyCategories,
          monthlySeries: [
            { name: "Billed (Gross)", data: billingSeries },
            { name: "Collected (Received)", data: collectionSeries },
          ],
          statusSeries: [
            breakdown.fullyPaid || 0,
            breakdown.partiallyPaid || 0,
            breakdown.unpaid || 0,
          ],
        });
      }
    });
  };

  const GetCustomerLedgerData = (pageNo) => {
    let options = {
      method: "GET",
    };
    const typeParam = activeTab?.creditTab
      ? "type=credit&"
      : activeTab?.debitTab
        ? "type=due&"
        : activeTab?.Tds
          ? "type=tds&"
          : "";

    const Url = `${apiUrl.get_transaction
      }?from=customer&customerId=${id}&${typeParam}${MainFilterHandler(
        pageStates
      )}`;
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          CustomerLedgerData: res?.data?.transaction,
          countsData: { ...res?.data?.counts },
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
        fetchInvoiceStats();
      }
    });
  };

  const GetCompanyList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_company + `?pageSize=${100}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          companyList: response?.data?.company,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        name: "",
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((pre) => ({
      ...pre,
      ...(type === "site" && { siteId: data?.site }),
      // ...(type && { officeType: data?.office }),
      ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
    }));
    if (type == "companyId") {
      GetSiteList(data?.companyId);
    }
  };

  const handleYearChange = (selectedYear) => {
    setPageStates((prev) => ({
      ...prev,
      year: selectedYear,
      sortByDate: isFirstYearChange ? prev.sortByDate : [],
    }));

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const timeoutId = useRef(null);
  const [expandedRow, setExpandedRow] = useState(null);

  const toggleRow = (index) => {
    if (expandedRow === index) {
      setExpandedRow(null);
    } else {
      setExpandedRow(index);
    }
  };

  const handleDocClick = (e, item) => {
    e.stopPropagation();
    if (item?.invoice?.id) {
      navigate(`${RoutesLink.invoice_detail}/${item.invoice.id}`);
    }
  };

  const handleLocalSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
        currentPage: 1,
      }));
    }, 300);
  };

  const isFiltered = activeTab?.creditTab || activeTab?.debitTab || activeTab?.Tds || pageStates?.searchQuery || selectedMonth;

  // Chronological order (oldest first)
  const sortedTransactions = Array.isArray(pageStates?.CustomerLedgerData)
    ? [...pageStates.CustomerLedgerData].reverse()
    : [];

  let currentBal = Number(pageStates?.countsData?.openingBalance) || 0;
  const ledgerEntries = sortedTransactions.map((item) => {
    const amount = Number(item?.amount) || 0;
    const isDebit = item?.type === "due" || item?.type === "debitNote";
    const isCredit = item?.type === "credit" || item?.type === "tds";

    if (item?.isOpeningBalance) {
      currentBal = amount;
    } else {
      if (isDebit) {
        currentBal += amount;
      } else if (isCredit) {
        currentBal -= amount;
      }
    }

    return {
      ...item,
      runningBalance: currentBal,
    };
  });

  const displayedEntries = ledgerEntries.filter((item) => {
    if (!selectedMonth) return true;
    const monthsArray = item?.invoice?.month || [];
    if (monthsArray.includes(selectedMonth)) return true;
    if (item?.invoice?.invoiceDate && moment(item?.invoice?.invoiceDate).format("MMM") === selectedMonth) return true;
    return false;
  });

  const exportToCSV = () => {
    const typeParam = activeTab?.creditTab
      ? "type=credit&"
      : activeTab?.debitTab
        ? "type=due&"
        : activeTab?.Tds
          ? "type=tds&"
          : "";

    // Query for the entire count of ledger transactions under the current active filters
    const exportStates = {
      ...pageStates,
      currentPage: 1,
      pageSize: pageStates?.count || 10000,
    };

    const Url = `${apiUrl.get_transaction}?from=customer&customerId=${id}&${typeParam}${MainFilterHandler(exportStates)}`;

    callApi(Url, { method: "GET" }).then((res) => {
      if (res?.status === true && res?.data?.transaction) {
        const allTransactions = res.data.transaction;

        // Chronological sort: oldest transaction first
        const sortedAll = Array.isArray(allTransactions)
          ? [...allTransactions].reverse()
          : [];

        let runningBal = Number(pageStates?.countsData?.openingBalance) || 0;
        const exportEntries = sortedAll.map((item) => {
          const amount = Number(item?.amount) || 0;
          const isDebit = item?.type === "due" || item?.type === "debitNote";
          const isCredit = item?.type === "credit" || item?.type === "tds";

          if (item?.isOpeningBalance) {
            runningBal = amount;
          } else {
            if (isDebit) {
              runningBal += amount;
            } else if (isCredit) {
              runningBal -= amount;
            }
          }

          return {
            ...item,
            runningBalance: runningBal,
          };
        });

        // Headers matching the main display layout
        const headers = ["Date", "Type", "Doc No.", "Site", "Invoice Month", "Particulars", "Debit (DR)", "Credit (CR)", "Running Balance"];

        const rows = exportEntries.map((item) => {
          const date = moment(item?.createdAt).format("DD/MM/YYYY");

          let type = "Transaction";
          if (item?.isOpeningBalance) type = "Opening Balance";
          else if (item?.type === "due") type = "Invoice";
          else if (item?.type === "debitNote") type = "Debit Note";
          else if (item?.type === "credit") type = "Payment";
          else if (item?.type === "tds") type = "TDS";

          let docNo = "";
          if (item?.type === "due" || item?.type === "tds") docNo = item?.invoice?.invoiceNumber || "";
          else if (item?.type === "debitNote" || item?.type === "credit") docNo = item?.transactionId || "";

          const siteName = item?.site?.name || "-";
          const invMonth = item?.invoice?.invoiceDate ? moment(item?.invoice?.invoiceDate).format("MMM YYYY") : "-";

          let particulars = "";
          if (item?.isOpeningBalance) particulars = "Opening Balance";
          else if (item?.type === "due") particulars = "Invoice Raised";
          else if (item?.type === "debitNote") particulars = "Debit Note Issued";
          else if (item?.type === "credit") particulars = `Payment Received (${item?.paymentMethod || "Bank"})`;
          else if (item?.type === "tds") particulars = "TDS Credit";

          const isDebit = item?.type === "due" || item?.type === "debitNote";
          const isCredit = item?.type === "credit" || item?.type === "tds";

          const debit = isDebit && !item?.isOpeningBalance ? item?.amount : "";
          const credit = isCredit && !item?.isOpeningBalance
            ? item?.amount
            : item?.type === "due" && !item?.isOpeningBalance
              ? (Number(item?.invoice?.receivedAmount) || 0)
              : "";
          const balance = !isFiltered ? item?.runningBalance : "";

          return [date, type, docNo, siteName, invMonth, particulars, debit, credit, balance];
        });

        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += [headers.join(","), ...rows.map(e => e.map(val => `"${String(val).replace(/"/g, '""')}"`).join(","))].join("\n");

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `Customer_Ledger_${location?.state?.name || "Statement"}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };

  const exportInvoicesReport = () => {
    const activeYear = pageStates.year || getCurrentFinancialYear();
    const Url = `${apiUrl.get_transaction}?from=customer&customerId=${id}&type=due&pageNumber=1&pageSize=100000&year=${activeYear}`;
    callApi(Url, { method: "GET" }).then((res) => {
      if (res?.status === true && res?.data?.transaction) {
        const txs = res.data.transaction;
        const invoicesMap = {};

        txs.forEach((item) => {
          if (item?.type === "due" && item?.invoice?.id) {
            invoicesMap[item.invoice.id] = {
              ...item.invoice,
              siteName: item?.site?.name || "-",
            };
          }
        });

        // Convert to rows and sort by invoice date descending (newest first)
        const invoicesList = Object.values(invoicesMap).sort((a, b) =>
          new Date(b.invoiceDate) - new Date(a.invoiceDate)
        );

        const headers = ["Invoice Date", "Invoice No.", "Site Name", "Invoice Month", "Invoice Amount (Gross)", "Received Amount", "Pending Amount", "Status"];

        const rows = invoicesList.map((inv) => {
          const date = inv.invoiceDate ? moment(inv.invoiceDate).format("DD/MM/YYYY") : "-";
          const invNo = inv.invoiceNumber || "-";
          const site = inv.siteName || "-";
          const month = inv.invoiceDate ? moment(inv.invoiceDate).format("MMM YYYY") : "-";
          const gross = Number(inv.grossAmount) || 0;
          const received = Number(inv.receivedAmount) || 0;
          const pending = Math.max(0, gross - received);
          const status = received >= gross ? "Paid" : "Pending";

          return [date, invNo, site, month, gross, received, pending, status];
        });

        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += [headers.join(","), ...rows.map(e => e.map(val => `"${String(val).replace(/"/g, '""')}"`).join(","))].join("\n");

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `Customer_Invoice_Summary_${location?.state?.name || "Report"}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };

  const printStatement = () => {
    window.print();
  };

  const customerName = location?.state?.name || "Customer Ledger Account";
  const customerEmail = location?.state?.email || "N/A";
  const customerPhone = location?.state?.phone || "N/A";
  const customerGst = location?.state?.gstNumber || "N/A";
  const customerStatus = location?.state?.status || location?.state?.siteStatus;

  return (
    <>
      <style>{`
        /* Scoped styles for professional ERP Customer Ledger */
        .ledger-detail-card {
          border: none;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
          background: #ffffff;
          overflow: hidden;
          margin-bottom: 24px;
        }
        .customer-profile-banner {
          background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
          color: #ffffff;
          padding: 24px;
          border-radius: 12px;
          margin-bottom: 24px;
          box-shadow: 0 4px 15px rgba(15, 23, 42, 0.15);
        }
        .profile-avatar {
          width: 54px;
          height: 54px;
          background-color: rgba(255, 255, 255, 0.1);
          border: 2px solid rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 22px;
          color: #38bdf8;
        }
        .profile-meta-label {
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #94a3b8;
        }
        .profile-meta-value {
          font-size: 13px;
          font-weight: 600;
          color: #f1f5f9;
        }

        /* KPI Grid */
        .kpi-cards-grid {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 12px;
          margin-bottom: 24px;
        }
        @media (max-width: 1400px) {
          .kpi-cards-grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }
        @media (max-width: 992px) {
          .kpi-cards-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        @media (max-width: 768px) {
          .kpi-cards-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 480px) {
          .kpi-cards-grid {
            grid-template-columns: 1fr;
          }
        }

        .kpi-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 16px;
          display: flex;
          flex-direction: column;
          position: relative;
          transition: all 0.25s ease;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
        }
        .kpi-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
        }
        .kpi-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 4px;
          border-radius: 12px 12px 0 0;
        }
        .kpi-card.kpi-opening::before { background-color: #64748b; }
        .kpi-card.kpi-debit::before { background-color: #ef4444; }
        .kpi-card.kpi-credit::before { background-color: #10b981; }
        .kpi-card.kpi-tds::before { background-color: #06b6d4; }
        .kpi-card.kpi-outstanding::before { background-color: #f59e0b; }
        .kpi-card.kpi-outstanding.advance::before { background-color: #10b981; }
        .kpi-card.kpi-paid-invoices::before { background-color: #10b981; }
        .kpi-card.kpi-pending-invoices::before { background-color: #f59e0b; }

        /* Status Badges */
        .status-badge {
          padding: 2px 6px;
          font-size: 10px;
          font-weight: 600;
          border-radius: 4px;
          margin-left: 6px;
          display: inline-block;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }
        .status-badge.paid {
          background-color: #d1fae5;
          color: #065f46;
          border: 1px solid #a7f3d0;
        }
        .status-badge.pending {
          background-color: #fef3c7;
          color: #92400e;
          border: 1px solid #fde68a;
        }

        .kpi-card-title {
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          color: #64748b;
          margin-bottom: 6px;
        }
        .kpi-card-value {
          font-size: 18px;
          font-weight: 700;
          color: #1e293b;
        }

        /* Tabs and Controls Bar */
        .erp-controls-bar {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 12px;
          margin-bottom: 20px;
        }
        .erp-filter-tabs {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
        .erp-tab-btn {
          background: #ffffff;
          border: 1px solid #cbd5e1;
          padding: 6px 14px;
          font-size: 12px;
          font-weight: 600;
          color: #475569;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .erp-tab-btn:hover {
          background: #f1f5f9;
          color: #1e293b;
        }
        .erp-tab-btn.active-all {
          border-color: #64748b;
          background: #64748b;
          color: #ffffff;
        }
        .erp-tab-btn.active-credit {
          border-color: #10b981;
          background: #10b981;
          color: #ffffff;
        }
        .erp-tab-btn.active-tds {
          border-color: #06b6d4;
          background: #06b6d4;
          color: #ffffff;
        }
        .erp-tab-btn.active-debit {
          border-color: #ef4444;
          background: #ef4444;
          color: #ffffff;
        }

        /* Ledger Table Design */
        .ledger-table-container {
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          overflow: hidden;
          background: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
        }
        .ledger-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 0;
          font-size: 13px;
        }
        .ledger-table th {
          background-color: #f8fafc;
          color: #475569;
          font-weight: 600;
          text-transform: uppercase;
          font-size: 11px;
          padding: 12px 16px;
          border-bottom: 2px solid #e2e8f0;
          white-space: nowrap;
        }
        .ledger-table td {
          padding: 12px 16px;
          border-bottom: 1px solid #f1f5f9;
          vertical-align: middle;
          color: #334155;
        }
        .ledger-table tbody tr.transaction-row {
          cursor: pointer;
          transition: background-color 0.15s ease;
        }
        .ledger-table tbody tr.transaction-row:hover td {
          background-color: #f8fafc;
        }
        .ledger-table tbody tr.expanded td {
          background-color: #f1f5f9;
        }
        .amount-debit {
          color: #ef4444;
          font-weight: 600;
          text-align: right;
        }
        .amount-credit {
          color: #10b981;
          font-weight: 600;
          text-align: right;
        }
        .amount-balance {
          font-weight: 700;
          color: #1e293b;
          text-align: right;
        }

        /* Details Expansion */
        .detail-row td {
          padding: 0 !important;
          border-bottom: 1px solid #cbd5e1;
          background-color: #f8fafc;
        }
        .detail-expand-wrapper {
          overflow: hidden;
          max-height: 0;
          transition: max-height 0.25s ease-out;
          padding: 0 24px;
        }
        .detail-expand-wrapper.open {
          max-height: 500px;
          padding: 16px 24px;
          border-top: 1px solid #e2e8f0;
          border-bottom: 1px solid #e2e8f0;
        }
        .detail-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 16px;
        }
        @media (max-width: 768px) {
          .detail-grid {
            grid-template-columns: 1fr;
          }
        }
        .detail-field {
          display: flex;
          flex-direction: column;
        }
        .detail-label {
          font-size: 9px;
          font-weight: 700;
          text-transform: uppercase;
          color: #64748b;
          margin-bottom: 2px;
          letter-spacing: 0.5px;
        }
        .detail-value {
          font-size: 12px;
          font-weight: 500;
          color: #1e293b;
        }

        /* Badge Designs */
        .badge-doc {
          font-size: 9px;
          font-weight: 700;
          padding: 3px 8px;
          border-radius: 4px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          display: inline-block;
        }
        .badge-doc.bg-invoice { background-color: #fee2e2; color: #ef4444; border: 1px solid #fecaca; }
        .badge-doc.bg-payment { background-color: #d1fae5; color: #10b981; border: 1px solid #a7f3d0; }
        .badge-doc.bg-tds { background-color: #ecfeff; color: #0891b2; border: 1px solid #cffafe; }
        .badge-doc.bg-debitnote { background-color: #dbeafe; color: #1d4ed8; border: 1px solid #bfdbfe; }
        .badge-doc.bg-opening { background-color: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; }

        /* Print Media Stylesheet */
        @media print {
          body {
            background: #ffffff !important;
            color: #000000 !important;
          }
          .content {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
          }
          .sidebar, .header, .navbar, .btn, .erp-filter-tabs, .dropdown, .pagination, .input-group,
          .main-header, button, select, .vr, .d-flex.justify-content-end, .border-top.pt-3, .erp-controls-bar {
            display: none !important;
          }
          .card, .card-body {
            border: none !important;
            box-shadow: none !important;
            padding: 0 !important;
            margin: 0 !important;
          }
          .customer-profile-banner {
            background: #ffffff !important;
            color: #000000 !important;
            border: 1px solid #cbd5e1 !important;
            box-shadow: none !important;
            margin-bottom: 20px !important;
            padding: 16px !important;
          }
          .profile-avatar {
            border-color: #cbd5e1 !important;
            color: #0f172a !important;
            background-color: #f1f5f9 !important;
          }
          .profile-meta-value {
            color: #000000 !important;
          }
          .profile-meta-label {
            color: #475569 !important;
          }
          .kpi-cards-grid {
            grid-template-columns: repeat(4, 1fr) !important;
            gap: 8px !important;
            margin-bottom: 20px !important;
          }
          .kpi-card {
            border: 1px solid #cbd5e1 !important;
            padding: 10px !important;
            box-shadow: none !important;
            background: #ffffff !important;
          }
          .kpi-card::before {
            display: none !important;
          }
          .ledger-table-container {
            border: 1px solid #000000 !important;
          }
          .ledger-table th {
            background-color: #f1f5f9 !important;
            color: #000000 !important;
            border-bottom: 2px solid #000000 !important;
          }
          .ledger-table td {
            border-bottom: 1px solid #cbd5e1 !important;
            color: #000000 !important;
          }
          .detail-expand-wrapper {
            max-height: none !important;
            padding: 10px 15px !important;
          }
        }
      `}</style>

      <div className="content container-fluid">
        <MainHeading
          showBackButton={true}
          title={"Customer Ledger Detail"}
          dateChangeHandler={dateChangeHandler}
          showDefaultDate={true}
          handleYearChange={handleYearChange}
        />

        {/* Customer Profile Banner */}
        <div className="customer-profile-banner">
          <div className="row align-items-center">
            <div className="col-auto">
              <div className="profile-avatar">
                {customerName.substring(0, 2).toUpperCase()}
              </div>
            </div>
            <div className="col">
              <h4 className="mb-1 fw-bold text-white">{customerName}</h4>
              <div className="d-flex flex-wrap gap-4 mt-2">
                <div>
                  <span className="profile-meta-label">GSTIN</span>
                  <div className="profile-meta-value">{customerGst}</div>
                </div>
                <div>
                  <span className="profile-meta-label">Email</span>
                  <div className="profile-meta-value">{customerEmail}</div>
                </div>
                <div>
                  <span className="profile-meta-label">Contact No.</span>
                  <div className="profile-meta-value">{customerPhone}</div>
                </div>
                <div>
                  <span className="profile-meta-label">Account Status</span>
                  <div className="profile-meta-value">
                    <span className={`badge ${customerStatus ? "bg-success" : "bg-secondary"}`}>
                      {customerStatus ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Layout Mode & Advanced Filter Toolbar */}
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4 p-3 bg-white border rounded shadow-sm" style={{ borderRadius: "10px" }}>
          <div className="d-flex align-items-center gap-2">
            <button
              className={`btn btn-sm ${viewMode === "table" ? "btn-primary" : "btn-outline-primary"} px-3 py-2`}
              style={{ borderRadius: "8px", fontWeight: "600" }}
              onClick={() => setViewMode("table")}
            >
              📋 Ledger Statement
            </button>
            <button
              className={`btn btn-sm ${viewMode === "dashboard" ? "btn-primary" : "btn-outline-primary"} px-3 py-2`}
              style={{ borderRadius: "8px", fontWeight: "600" }}
              onClick={() => setViewMode("dashboard")}
            >
              📊 Financial Insights
            </button>
          </div>

          <div className="d-flex align-items-center gap-3 flex-wrap">
            {/* Site Filter Dropdown */}
            <div className="d-flex align-items-center gap-2">
              <span className="text-muted fw-semibold" style={{ fontSize: "12px" }}>Site:</span>
              <select
                className="form-select form-select-sm border bg-white"
                style={{ minWidth: "180px", borderRadius: "8px", fontSize: "12px", height: "36px" }}
                value={pageStates.siteId}
                onChange={(e) => {
                  setPageStates((pre) => ({ ...pre, siteId: e.target.value, currentPage: 1 }));
                }}
              >
                <option value="">All Sites</option>
                {pageStates.siteList?.map((item) => {
                  const siteObj = item?.site || item;
                  return (
                    <option key={siteObj?.id} value={siteObj?.id}>
                      {siteObj?.name || siteObj?.siteName || "Unnamed Site"}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>

        {/* Controls & Table Card */}
        {viewMode === "table" ? (
          <div className="card mb-4 shadow-sm border-0">
            <div className="card-body">

              {/* Control Bar: Search & Action buttons */}
              <div className="erp-controls-bar d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
                <div className="d-flex align-items-center gap-3 flex-grow-1" style={{ maxWidth: "600px" }}>
                  <div className="input-group flex-grow-1">
                    <span className="input-group-text bg-white border-end-0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search text-muted" viewBox="0 0 16 16">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                      </svg>
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0 text-sm"
                      style={{ fontSize: "13px" }}
                      placeholder="Search by doc number, UTR, creator, remarks..."
                      onChange={handleLocalSearchChange}
                    />
                  </div>
                  <div style={{ minWidth: "160px" }}>
                    <select
                      className="form-select form-select-sm border bg-white"
                      style={{ borderRadius: "8px", fontSize: "12px", height: "36px" }}
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                    >
                      <option value="">All Invoice Months</option>
                      <option value="Jan">Jan (January)</option>
                      <option value="Feb">Feb (February)</option>
                      <option value="Mar">Mar (March)</option>
                      <option value="Apr">Apr (April)</option>
                      <option value="May">May (May)</option>
                      <option value="Jun">Jun (June)</option>
                      <option value="Jul">Jul (July)</option>
                      <option value="Aug">Aug (August)</option>
                      <option value="Sep">Sep (September)</option>
                      <option value="Oct">Oct (October)</option>
                      <option value="Nov">Nov (November)</option>
                      <option value="Dec">Dec (December)</option>
                    </select>
                  </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <button className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1 fw-semibold" onClick={exportInvoicesReport}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-text" viewBox="0 0 16 16">
                      <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" />
                      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                    </svg>
                    Export Invoices Summary
                  </button>
                  <button className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 fw-semibold" onClick={exportToCSV}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-excel" viewBox="0 0 16 16">
                      <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z" />
                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                    </svg>
                    Export CSV
                  </button>
                  <button className="btn btn-primary btn-sm d-flex align-items-center gap-1 fw-semibold" onClick={printStatement}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-printer" viewBox="0 0 16 16">
                      <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                      <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v3a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3h8z" />
                    </svg>
                    Print Ledger
                  </button>
                </div>
              </div>

              {/* Filter Tabs Row */}
              <div className="erp-filter-tabs">
                <button
                  className={`erp-tab-btn ${activeTab?.debitTab ? "active-debit" : ""}`}
                  onClick={() => setActiveTab({ debitTab: !activeTab.debitTab, creditTab: false, Tds: false })}
                >
                  Invoices / DR
                </button>
                <button
                  className={`erp-tab-btn ${activeTab?.creditTab ? "active-credit" : ""}`}
                  onClick={() => setActiveTab({ creditTab: !activeTab.creditTab, debitTab: false, Tds: false })}
                >
                  Payments / CR
                </button>
                <button
                  className={`erp-tab-btn ${activeTab?.Tds ? "active-tds" : ""}`}
                  onClick={() => setActiveTab({ Tds: !activeTab.Tds, creditTab: false, debitTab: false })}
                >
                  TDS Credit
                </button>
              </div>

              {/* Table Container */}
              <div className="ledger-table-container">
                {pageStates?.tableLoader ? (
                  <div className="d-flex justify-content-center my-5">
                    <Spinner color="primary" />
                  </div>
                ) : displayedEntries && displayedEntries.length > 0 ? (
                  <div className="table-responsive">
                    <table className="ledger-table">
                      <thead>
                        <tr>
                          <th style={{ width: "90px", textAlign: "center" }}>Date</th>
                          <th style={{ width: "100px" }}>Doc Type</th>
                          <th style={{ width: "130px" }}>Doc/Ref No.</th>
                          <th>Site</th>
                          <th style={{ width: "110px", textAlign: "center" }}>Invoice Month</th>
                          <th>Particulars</th>
                          <th style={{ width: "120px", textAlign: "right" }}>Debit (DR)</th>
                          <th style={{ width: "120px", textAlign: "right" }}>Credit (CR)</th>
                          {!isFiltered && <th style={{ width: "140px", textAlign: "right" }}>Running Balance</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {displayedEntries.map((item, index) => {
                          const isDebit = item?.type === "due" || item?.type === "debitNote";
                          const isCredit = item?.type === "credit" || item?.type === "tds";
                          const isOpenBal = item?.isOpeningBalance;

                          let docBadge = "";
                          let badgeClass = "";
                          let docNo = "";
                          let particularsText = "";

                          if (isOpenBal) {
                            docBadge = "Opening Balance";
                            badgeClass = "bg-opening";
                            docNo = "-";
                            particularsText = "Opening Balance";
                          } else if (item?.type === "due") {
                            docBadge = "Invoice";
                            badgeClass = "bg-invoice";
                            docNo = item?.invoice?.invoiceNumber || "-";
                            particularsText = "Invoice Raised";
                          } else if (item?.type === "debitNote") {
                            docBadge = "Debit Note";
                            badgeClass = "bg-debitnote";
                            docNo = item?.transactionId || (item?.invoice?.invoiceNumber ? `(${item?.invoice?.invoiceNumber})` : "-");
                            particularsText = "Debit Note Issued";
                          } else if (item?.type === "credit") {
                            docBadge = "Payment";
                            badgeClass = "bg-payment";
                            docNo = item?.transactionId || "-";
                            particularsText = `Payment Received (${item?.paymentMethod || "Bank"})`;
                          } else if (item?.type === "tds") {
                            docBadge = "TDS";
                            badgeClass = "bg-tds";
                            docNo = item?.invoice?.invoiceNumber ? `TDS-${item?.invoice?.invoiceNumber}` : "-";
                            particularsText = "TDS Credit";
                          }

                          const isRowOpen = expandedRow === index;

                          return (
                            <>
                              <tr
                                key={`row-${index}`}
                                className={`transaction-row ${isRowOpen ? "expanded" : ""}`}
                                onClick={() => toggleRow(index)}
                              >
                                <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                  {moment(item?.createdAt).format("DD/MM/YYYY")}
                                </td>
                                <td>
                                  <div className="d-flex align-items-center gap-1">
                                    <span className={`badge-doc ${badgeClass}`}>
                                      {docBadge}
                                    </span>
                                    {item?.type === "due" && item?.invoice && (
                                      Number(item?.invoice?.receivedAmount) >= Number(item?.invoice?.grossAmount) ? (
                                        <span className="status-badge paid">Paid</span>
                                      ) : (
                                        <span className="status-badge pending">Pending</span>
                                      )
                                    )}
                                  </div>
                                </td>
                                <td className="fw-semibold">
                                  {isOpenBal ? (
                                    "-"
                                  ) : item?.invoice?.id ? (
                                    <span
                                      className="text-primary text-decoration-underline cursor-pointer"
                                      onClick={(e) => handleDocClick(e, item)}
                                    >
                                      {docNo}
                                    </span>
                                  ) : (
                                    docNo
                                  )}
                                </td>
                                <td>{item?.site?.name || "-"}</td>
                                <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                  {item?.invoice?.invoiceDate ? moment(item?.invoice?.invoiceDate).format("MMM YYYY") : "-"}
                                </td>
                                <td className="text-muted text-truncate" style={{ maxWidth: "250px" }}>
                                  {particularsText}
                                </td>
                                <td className="amount-debit">
                                  {isDebit && !isOpenBal ? formatAmount(item?.amount || 0) : "-"}
                                </td>
                                <td className="amount-credit">
                                  {isCredit && !isOpenBal ? (
                                    formatAmount(item?.amount || 0)
                                  ) : item?.type === "due" && !isOpenBal ? (
                                    <span className="text-success fw-semibold">
                                      {formatAmount(Number(item?.invoice?.receivedAmount) || 0)}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                {!isFiltered && (
                                  <td className="amount-balance">
                                    {formatAmount(item?.runningBalance)}
                                  </td>
                                )}
                              </tr>

                              {/* Expandable Details Row */}
                              <tr key={`detail-${index}`} className="detail-row">
                                <td colSpan={!isFiltered ? 9 : 8}>
                                  <div className={`detail-expand-wrapper ${isRowOpen ? "open" : ""}`}>
                                    <div className="detail-grid">
                                      <div className="detail-field">
                                        <span className="detail-label">Audit Information</span>
                                        <span className="detail-value">
                                          Created by: {item?.user?.name || "System"} <br />
                                          Designation: {item?.user?.designation?.name || "N/A"} <br />
                                          Department: {item?.user?.department?.name || "N/A"} <br />
                                          Site: {item?.site?.name || "N/A"}
                                        </span>
                                      </div>

                                      {item?.type === "credit" && (
                                        <div className="detail-field">
                                          <span className="detail-label">Payment & Bank Details</span>
                                          <span className="detail-value">
                                            Method: {item?.paymentMethod} <br />
                                            {item?.paymentMethod === "Cash" ? (
                                              <>Ref Name: {item?.referenceName || "N/A"}</>
                                            ) : (
                                              <>
                                                UTR/Ref No: {item?.utr || "N/A"} <br />
                                                Bank Name: {item?.bankName || "N/A"} <br />
                                                AC No: {item?.accountNumber || "N/A"} <br />
                                                AC Holder: {item?.accountHolderName || "N/A"}
                                              </>
                                            )}
                                          </span>
                                        </div>
                                      )}

                                      {item?.type === "due" && (
                                        <div className="detail-field">
                                          <span className="detail-label">Invoice Details</span>
                                          <span className="detail-value">
                                            Invoice Date: {item?.invoice?.invoiceDate ? moment(item?.invoice?.invoiceDate).format("DD/MM/YYYY") : "N/A"} <br />
                                            Invoice Amount: {formatAmount(item?.invoice?.grossAmount || 0)} <br />
                                            Paid Amount: {formatAmount(item?.invoice?.receivedAmount || 0)} <br />
                                            Remaining Due: {formatAmount(Math.max(0, Number(item?.invoice?.grossAmount || 0) - Number(item?.invoice?.receivedAmount || 0)))} <br />
                                            Created On: {moment(item?.createdAt).format("DD/MM/YYYY hh:mm A")}
                                          </span>
                                        </div>
                                      )}

                                      {item?.type === "tds" && (
                                        <div className="detail-field">
                                          <span className="detail-label">TDS Reference</span>
                                          <span className="detail-value">
                                            Deducted against Invoice No: {item?.invoice?.invoiceNumber || "N/A"} <br />
                                            Transaction Date: {item?.transactionDate ? moment(item?.transactionDate).format("DD/MM/YYYY") : "N/A"}
                                          </span>
                                        </div>
                                      )}

                                      <div className="detail-field">
                                        <span className="detail-label">Remarks & Notes</span>
                                        <span className="detail-value text-wrap">
                                          {item?.remark || item?.Voucher?.remark || "--"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="d-flex flex-column justify-content-center align-items-center py-5 no-data-error bg-light">
                    <NoRecordIcon />
                    <span className="mt-2 text-muted fw-semibold">No transactions found for the selected filters.</span>
                  </div>
                )}
              </div>

              {/* Pagination block */}
              <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
                <div className="d-flex align-items-center gap-2">
                  {pageStates?.count > 0 && !pageStates?.tableLoader && (
                    <div className="dropdown short">
                      <button
                        className="btn dropdown-toggle border btn-sm bg-white"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {pageStates?.pageSize} Entries
                      </button>
                      <ul className="dropdown-menu">
                        {[10, 20, 30, 40, 50].map((value) => (
                          <li key={value}>
                            <button
                              className={`dropdown-item ${pageStates?.pageSize === value && "active"}`}
                              onClick={() => handleChangePageSize(value)}
                            >
                              {value}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <div>
                    {pageStates?.count > 0 && !pageStates?.tableLoader && (
                      <p
                        className="mb-0 text-muted fw-medium text-uppercase"
                        style={{ fontSize: "10px" }}
                      >
                        {`Showing ${pageStates?.currentPage * pageStates?.pageSize - (pageStates?.pageSize - 1)} to ${pageStates?.currentPage * pageStates?.pageSize < pageStates?.count ? pageStates?.currentPage * pageStates?.pageSize : pageStates?.count} of ${pageStates?.count} entries`}
                      </p>
                    )}
                  </div>
                </div>

                <PaginationComponent
                  currentPage={pageStates?.currentPage}
                  PageChangeHandler={PageChangeHandler}
                  totalPages={pageStates?.totalPages}
                />
              </div>

            </div>
          </div>
        ) : (
          <div className="financial-dashboard-wrapper">
            {/* Row 1: Executive KPI Cards Grid */}
            <div className="row g-4 mb-4">
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="kpi-card h-100 shadow-sm border p-3 bg-white transition-all hover-scale" style={{ borderRadius: "10px", borderLeft: "4px solid #8b5cf6" }}>
                  <span className="text-muted fw-semibold text-uppercase" style={{ fontSize: "10px", letterSpacing: "0.5px" }}>Total Contract Value</span>
                  <h4 className="fw-bold mt-2 mb-1" style={{ color: "#8b5cf6" }}>{formatAmount(invoiceStats.totalContractValue)}</h4>
                  <span className="text-muted" style={{ fontSize: "11px" }}>Total contract amount</span>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="kpi-card h-100 shadow-sm border p-3 bg-white transition-all hover-scale" style={{ borderRadius: "10px", borderLeft: "4px solid #3b82f6" }}>
                  <span className="text-muted fw-semibold text-uppercase" style={{ fontSize: "10px", letterSpacing: "0.5px" }}>Total Billed</span>
                  <h4 className="fw-bold mt-2 mb-1" style={{ color: "#0f172a" }}>{formatAmount(invoiceStats.totalInvoiceAmount)}</h4>
                  <span className="text-muted" style={{ fontSize: "11px" }}>Total invoice gross</span>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="kpi-card h-100 shadow-sm border p-3 bg-white transition-all hover-scale" style={{ borderRadius: "10px", borderLeft: "4px solid #10b981" }}>
                  <span className="text-muted fw-semibold text-uppercase" style={{ fontSize: "10px", letterSpacing: "0.5px" }}>Total Collected</span>
                  <h4 className="fw-bold mt-2 mb-1 text-success">{formatAmount(invoiceStats.totalReceivedAmount)}</h4>
                  <span className="text-muted" style={{ fontSize: "11px" }}>Inflow received</span>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="kpi-card h-100 shadow-sm border p-3 bg-white transition-all hover-scale" style={{ borderRadius: "10px", borderLeft: "4px solid #f59e0b" }}>
                  <span className="text-muted fw-semibold text-uppercase" style={{ fontSize: "10px", letterSpacing: "0.5px" }}>Total Pending</span>
                  <h4 className="fw-bold mt-2 mb-1 text-warning">{formatAmount(invoiceStats.pendingAmount)}</h4>
                  <span className="text-muted" style={{ fontSize: "11px" }}>Pending receivables</span>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="kpi-card h-100 shadow-sm border p-3 bg-white transition-all hover-scale" style={{ borderRadius: "10px", borderLeft: "4px solid #06b6d4" }}>
                  <span className="text-muted fw-semibold text-uppercase" style={{ fontSize: "10px", letterSpacing: "0.5px" }}>TDS Deducted</span>
                  <h4 className="fw-bold mt-2 mb-1 text-info">{formatAmount(invoiceStats.tdsAmount)}</h4>
                  <span className="text-muted" style={{ fontSize: "11px" }}>TDS ledger credit</span>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4">
                <div className="kpi-card h-100 shadow-sm border p-3 bg-white transition-all hover-scale" style={{ borderRadius: "10px", borderLeft: "4px solid #6366f1" }}>
                  <span className="text-muted fw-semibold text-uppercase" style={{ fontSize: "10px", letterSpacing: "0.5px" }}>Collection Efficiency</span>
                  <h4 className="fw-bold mt-2 mb-1 text-primary">
                    {(Number(invoiceStats.collectionEfficiency) || 0).toFixed(2)}%
                  </h4>
                  <div className="progress mt-2" style={{ height: "4px" }}>
                    <div
                      className="progress-bar bg-primary"
                      role="progressbar"
                      style={{ width: `${Number(invoiceStats.collectionEfficiency) || 0}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Row 2: Visual Charts row */}
            <div className="row g-4 mb-4">
              {/* Chart 1: Month-wise Billing vs Collections */}
              <div className="col-12 col-lg-8">
                <div className="card shadow-sm border p-3 bg-white h-100" style={{ borderRadius: "12px" }}>
                  <h5 className="fw-bold mb-3 text-slate-800" style={{ fontSize: "14px" }}>📈 Billing vs Collection Trend</h5>
                  {dashboardData.monthlyCategories.length > 0 ? (
                    <Chart
                      options={{
                        chart: { type: "bar", toolbar: { show: false } },
                        plotOptions: { bar: { horizontal: false, columnWidth: "40%", borderRadius: 3 } },
                        xaxis: {
                          categories: dashboardData.monthlyCategories,
                          labels: { style: { colors: "#64748b", fontWeight: 500, fontSize: "11px" } }
                        },
                        yaxis: {
                          labels: {
                            style: { colors: "#64748b" },
                            formatter: (val) => `₹${Number(val).toLocaleString("en-IN")}`
                          }
                        },
                        colors: ["#3b82f6", "#10b981"],
                        dataLabels: { enabled: false },
                        legend: { position: "top", horizontalAlign: "right", fontSize: "11px" },
                        tooltip: { y: { formatter: (val) => `₹${Number(val).toLocaleString("en-IN")}` } }
                      }}
                      series={dashboardData.monthlySeries}
                      type="bar"
                      height={280}
                    />
                  ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center h-100 py-5 bg-light rounded text-center">
                      <NoRecordIcon />
                      <span className="mt-2 text-muted fw-semibold" style={{ fontSize: "12px" }}>No monthly trend details.</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Chart 2: Invoice Payment Status breakdown */}
              <div className="col-12 col-lg-4">
                <div className="card shadow-sm border p-3 bg-white h-100" style={{ borderRadius: "12px" }}>
                  <h5 className="fw-bold mb-3 text-slate-800" style={{ fontSize: "14px" }}>📊 Invoice Payment Status</h5>
                  {dashboardData.statusSeries?.some(v => v > 0) ? (
                    <Chart
                      options={{
                        chart: { type: "donut" },
                        labels: ["Fully Paid", "Partially Paid", "Unpaid / Pending"],
                        colors: ["#10b981", "#f59e0b", "#ef4444"],
                        legend: { position: "bottom", fontSize: "11px" },
                        dataLabels: { enabled: false },
                        plotOptions: {
                          pie: {
                            donut: {
                              size: "70%",
                              labels: {
                                show: true,
                                total: {
                                  show: true,
                                  label: "Total Invoices",
                                  fontSize: "11px",
                                  formatter: () => dashboardData.statusSeries.reduce((a, b) => a + b, 0)
                                }
                              }
                            }
                          }
                        }
                      }}
                      series={dashboardData.statusSeries}
                      type="donut"
                      height={280}
                    />
                  ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center h-100 py-5 bg-light rounded text-center">
                      <NoRecordIcon />
                      <span className="mt-2 text-muted fw-semibold" style={{ fontSize: "12px" }}>No status breakdown details.</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Row 3: Site & Work Order Performance */}
            <div className="row g-4">
              <div className="col-12">
                <div className="card shadow-sm border-0 bg-white" style={{ borderRadius: "12px" }}>
                  <div className="card-header bg-white border-bottom py-3">
                    <h5 className="fw-bold mb-0 text-slate-800" style={{ fontSize: "14px" }}>📋 Site & Work Order Financial Breakdown</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table align-middle table-hover mb-0" style={{ fontSize: "12px" }}>
                      <thead className="bg-light text-slate-700">
                        <tr>
                          <th className="px-3 py-3" style={{ fontWeight: "600" }}>Work Order No.</th>
                          <th className="py-3" style={{ fontWeight: "600" }}>Site Name</th>
                          <th className="py-3 text-center" style={{ fontWeight: "600" }}>Invoices</th>
                          <th className="py-3 text-end" style={{ fontWeight: "600" }}>Total Billed</th>
                          <th className="py-3 text-end" style={{ fontWeight: "600" }}>Collected</th>
                          <th className="py-3 text-end" style={{ fontWeight: "600" }}>Pending Dues</th>
                          <th className="px-3 py-3 text-end" style={{ fontWeight: "600" }}>Collection Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboardData.workOrders?.length > 0 ? (
                          dashboardData.workOrders.map((wo, i) => {
                            const rate = wo.totalBilled > 0 ? ((wo.totalCollected / wo.totalBilled) * 100).toFixed(1) : "0.0";
                            return (
                              <tr key={i}>
                                <td className="px-3 py-2 fw-semibold">
                                  <span
                                    className="text-primary text-decoration-underline cursor-pointer"
                                    onClick={() => {
                                      console.log("WorkOrder clicked:", wo);
                                      const woId = wo.workorderId || wo.workOrderId || wo.id || wo.workOrder?.id || wo.work_order_id;
                                      if (woId) {
                                        navigate(`${RoutesLink.work_order_detail}/${woId}`);
                                      } else {
                                        alert("Work Order ID is missing in API response. Response Object: " + JSON.stringify(wo));
                                      }
                                    }}
                                  >
                                    {wo.workOrderNumber}
                                  </span>
                                </td>
                                <td className="py-2 fw-medium">{wo.siteName}</td>
                                <td className="py-2 text-center">
                                  <span className="badge bg-light text-dark border px-2 py-1" style={{ fontSize: "10px" }}>{wo.invoiceCount}</span>
                                </td>
                                <td className="py-2 text-end fw-semibold text-danger">{formatAmount(wo.totalBilled)}</td>
                                <td className="py-2 text-end fw-semibold text-success">{formatAmount(wo.totalCollected)}</td>
                                <td className="py-2 text-end fw-semibold text-warning">{formatAmount(wo.totalPending)}</td>
                                <td className="px-3 py-2 text-end">
                                  <div className="d-flex align-items-center justify-content-end gap-2">
                                    <span className="fw-bold" style={{ fontSize: "11px", color: Number(rate) >= 90 ? "#10b981" : Number(rate) >= 50 ? "#f59e0b" : "#ef4444" }}>{rate}%</span>
                                    <div className="progress" style={{ width: "45px", height: "4px" }}>
                                      <div
                                        className={`progress-bar ${Number(rate) >= 90 ? "bg-success" : Number(rate) >= 50 ? "bg-warning" : "bg-danger"}`}
                                        role="progressbar"
                                        style={{ width: `${rate}%` }}
                                      ></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center py-5 text-muted fw-semibold">
                              No work order statistics found for this customer.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
